<!-- <div class="lds-top-button-group-container">
<mat-button-toggle-group #group="matButtonToggleGroup" [value]="selectedVal" (change)="onValChange(group.value)">
  <mat-button-toggle value="devices/energy" routerLink="energy">Energy</mat-button-toggle>
  <mat-button-toggle value="devices/heating" routerLink="heating">Heating</mat-button-toggle>
  <mat-button-toggle value="devices/switch" routerLink="switch">Switch</mat-button-toggle>
</mat-button-toggle-group>
</div>
<router-outlet></router-outlet> -->

<div>
  @for (room of this.rooms; track room) {
    <div>
      @if (room.order.length > 0) {
        <h1 class="mdl-layout-title" >{{room.name}}</h1>
        <div class="devices-div">
          @for (featureSetId of room.order; track featureSetId) {
            <div>
              <lds-featureset-card-all-devices [featureSetId]="featureSetId"></lds-featureset-card-all-devices>
            </div>
          }
        </div>
      }
    </div>
  }

</div>


